import { render, staticRenderFns } from "./PageManageAttribute.vue?vue&type=template&id=3ed7c4f4&"
import script from "./PageManageAttribute.vue?vue&type=script&lang=js&"
export * from "./PageManageAttribute.vue?vue&type=script&lang=js&"
import style0 from "./PageManageAttribute.vue?vue&type=style&index=0&id=3ed7c4f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports